import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of } from 'rxjs';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml-input',
  templateUrl: './auto-ml-input.component.html',
  styleUrls: ['./auto-ml-input.component.scss']
})
export class AutoMlInputComponent {

  uploadedFileName:string | null = null;
  uploadFile: any =null;
  isLoading:boolean = false;

  constructor(
    private toast:ToastrService,
    private as:AutoMlService
  ){}

  onFileChange(event: Event | any,type:string): void {
    if(type ==='input'){
      const file = event.target.files[0];
      const type = String(file.name).split('.')[String(file.name).split('.').length-1];
      if (type==='csv') {
        this.uploadedFileName = file.name;
        this.uploadFile = file;
      }
      else{
        this.toast.warning('Invalid doc');
        this.uploadedFileName =null;
        this.uploadFile;
      }
      
    }else{
        this.uploadedFileName = event[0].name;
        this.uploadFile = event[0];
    }
  }

  upload(){
    this.isLoading = true;
    const file = new FormData();
    file.append('file',this.uploadFile);
    this.as.uploadFile(file)
    .pipe(
      finalize(()=>{
        this.isLoading =false;
      }),
      catchError((e:any)=>{
        this.toast.error(e.error.error)
        return of(false)
      })
    )
    .subscribe((el:any)=>{
      if(el.status==='success'){
        this.toast.success(el.message);
        this.as.isInput = true;
        this.as.stepperOptions[0].step = true;
        this.as.getTableColums();
      }
      
    })
  }
}
